import styled from 'styled-components';
import colors from '../../styles/colors';

export const OuterWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	background-color: ${colors.neutralBackground};
`;

export const Container = styled.div`
	height: 100%;
	width: 100%;
	overflow: auto;
	padding: 1rem;
	padding-top: 2.75rem;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	width: 100%;
	max-width: 71.75rem;
	margin: 0 auto;
`;

export const OptionsCard = styled.div`
	display: flex;
	flex-direction: column;

	& > * + * {
		margin-top: 1rem;
	}
`;

export const OptionButton = styled.button`
	display: flex;
	flex-direction: column;
	padding: 0.5rem;
	appearance: none;
	border-radius: 0.25rem;
	background-color: transparent;
	border: 1px solid ${colors.neutralText};
	align-items: center;

	@media screen and (min-width: 768px) {
		flex-direction: row;
		text-align: left;
		padding: 1.5rem 1rem;

		& > * + * {
			margin-left: 1rem;
		}
	}

	.circle {
		width: 1.25rem;
		height: 1.25rem;
		border: 1px solid ${colors.neutralText};
		border-radius: 9999px;
		margin-bottom: 0.5rem;

		&.checked {
			position: relative;
			overflow: hidden;
			&::after {
				position: absolute;
				border-radius: 9999px;
				inset: 2px;
				content: '';
				background-color: ${colors.brandPrimary};
			}
		}

		@media screen and (min-width: 768px) {
			margin-bottom: 0;
		}
	}
	.icon {
		color: ${colors.brandPrimary};
		width: 2.625rem;
		height: 2.625rem;
	}
	.content-info {
	}
`;

export const PendingWrapper = styled.div`
	margin-top: -0.5rem;
`;

export const NoDataFound = styled.div`
	margin-top: 0.5rem;
`;
